import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Search, Bell, HelpCircle, Settings } from "lucide-react";
import './style.scss'

const PAGE_LABELS = {
    "/": "Dashboard",
    "/dashboard": "Dashboard",
    "/history": "Document History",
    "/wizdoc": "Wizdoc",
    "/apis": "APIs",
    "/billing": "Billing & Usage",
    "/support": "Support",
    "/pages/account-settings": "Account Settings",
};

const getInitials = (name = "") => {
    return name
        .trim()
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((word) => word[0].toUpperCase())
        .join("");
};

export default function Topbar() {
    const [searchVal, setSearchVal] = useState("");
    const location = useLocation();
    const navigate = useNavigate()

    let pageLabel = PAGE_LABELS[location.pathname];

    // handle dynamic routes like /cases/123
    if (location.pathname.startsWith("/cases/") && !pageLabel) {
        pageLabel = "Case Investigation";
    }

    if (!pageLabel) pageLabel = "Dashboard";

    // ── Pull user from localStorage ──
    const firstName = localStorage.getItem("first_name") || "";
    const lastName = localStorage.getItem("last_name") || "";
    const fullName = `${firstName} ${lastName}`.trim() || "User";
    const initials = getInitials(fullName);
    const displayName = lastName ? `${firstName} ${lastName[0]}.` : firstName;


    return (
        <header className="topbar" role="banner">

            {/* Breadcrumb */}
            <div className="topbar__breadcrumb">
                <span>InsightAI</span>
                <span className="topbar__breadcrumb-sep" aria-hidden="true">/</span>
                <span className="topbar__breadcrumb-current">{pageLabel}</span>
            </div>

            {/* Search */}
            {/* <div className="topbar__search">
        <Search size={14} aria-hidden="true" />
        <input
          type="search"
          placeholder="Search cases, alerts, entities…"
          value={searchVal}
          onChange={(e) => setSearchVal(e.target.value)}
          aria-label="Global search"
        />
      </div> */}

            {/* Actions */}
            <div className="topbar__actions">
                {/* <button className="topbar__icon-btn" aria-label="Notifications">
          <Bell size={16} />
          <span className="topbar__notif-dot" aria-hidden="true" />
        </button> */}

                {/* <button className="topbar__icon-btn" aria-label="Help">
          <HelpCircle size={16} />
        </button> */}

                {/* <button className="topbar__icon-btn" aria-label="Settings">
          <Settings size={16} />
        </button> */}

                <div className="topbar__user" onClick={() => navigate('/pages/account-settings')}>
                    <div className="topbar__user-avatar">{initials}</div>
                    <span className="topbar__user-name">{displayName}</span>
                </div>
            </div>

        </header>
    );
}